import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { croCount, projectColor, THEME } from '../utils/trackerConfig';

// One pill per project (plus "All CROs"), laid out as an EVEN GRID of equal pills: five in a row when there is room, and on a small screen
// three and two (never one long ragged column, never a scroll arrow). The selected pill takes its project's colour and a thick line under it.
// The label and the count may sit on two lines inside a pill, so a name is never cut.
function Pill({ selected, onClick, dot, label, count, soft, text, main }) {
  return (
    <ButtonBase
      role="tab"
      aria-selected={selected}
      onClick={onClick}
      sx={{
        gap: 0.75,
        px: 1,
        py: 0.75,
        minHeight: 40,
        alignContent: 'center',
        borderRadius: '10px 10px 0 0',
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 1.2,
        textAlign: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        color: selected ? text : '#475569',
        backgroundColor: selected ? soft : '#F8FAFC',
        border: `1px solid ${selected ? main : THEME.grid}`,
        borderBottomWidth: 0,
        boxShadow: selected ? `inset 0 -4px 0 ${main}` : 'none',
        '&:hover': { backgroundColor: selected ? soft : '#EEF2F7' },
      }}
    >
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6 }}>
        {dot && <Box component="span" sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: dot, flexShrink: 0 }} />}
        {label}
      </Box>
      <Box component="span" sx={{ fontWeight: 600, opacity: 0.8 }}>
        ({count})
      </Box>
    </ButtonBase>
  );
}

export default function ProjectTabs({ value, onChange, allCount, projects }) {
  return (
    <Box
      role="tablist"
      sx={{
        flex: '1 1 440px',
        minWidth: 0,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(96px, 1fr))',
        gap: 0.5,
        alignItems: 'stretch',
      }}
    >
      <Pill selected={value === 'all'} onClick={() => onChange('all')} label="All CROs" count={allCount} soft={THEME.primaryLine} text={THEME.primaryDark} main={THEME.primary} />
      {projects.map((p) => {
        const pc = projectColor(p.key);
        return <Pill key={p.key} selected={value === p.key} onClick={() => onChange(p.key)} dot={pc.main} label={p.label} count={croCount(p.cros)} soft={pc.soft} text={pc.text} main={pc.main} />;
      })}
    </Box>
  );
}
